<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import flashMessage from "../../components/flashMessahe";
import moment from "moment";
import AgentDetails from "../../components/agent-details";
import ErrorMessage from "../../components/error-message";
export default {
  components: { ErrorMessage,Layout, PageHeader, flashMessage ,AgentDetails},
  data() {
    return {
      title: "Agent Approval List",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "Agent Approval List",
          active: true,
        },
      ],
      agents: [],
      errors: null,
      reason: "",
      show:false,
      agentUuid:"",
      approvalRemark:"",
      agentApproved:false,
        visible:false,
        message:"",
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_email:"",
        search_phone:"",
        search_pcode:"",
        search_pnumber:"",
        search:"",
    };
  },
  mounted() {
    this.getAgentList();
  },
    computed: {
        filteredList() {
            return this.agents.filter(agent => {
                return (agent.users[0].username==null ? '' : agent.users[0].username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && agent.email.toLowerCase().includes(this.search_email.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
    onPending(value){
      this.show=false;
    },
        searchFilterFunc2(val) {
            this.search=val;
        },

        onApproval(value){
      this.agentApproved=true;
      if(this.agentApproved==true){
        this.show=false;
          this.reason = this.reason;
          this.approve(this.agentUuid);
      }
    },
      onRejection(value){
          if(this.agentApproved==false){
              this.show=false;
              this.reason = this.reason;
              this.reject(this.agentUuid);
          }
      },
      onApprovalMessage(value) {
        this.reason = value;
      //console.log(value);
    },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.status == 200) {
                let agents = response.data.data;
                let filteredAgent=[];
                let i;
                for(i=0;i<agents.length;i++){
                    if(agents[i].approval_status== 'pending' && agents[i].agency_information[0] != undefined){
                        filteredAgent.push(agents[i]);
                    }
                }
                this.agents=filteredAgent;
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      approvalAction(agent){
          var _this = this;
          this.agentUuid=agent.uuid;
          this.show=true;
      },

    async approve(uuid) {
      var _this = this;
      try {
        axios
          .put("/api/agent/approve", {
            accessToken: localStorage.getItem("access_tocken"),
            approval_remark: _this.reason,
            uuid: uuid,
          })
          .then(function (response) {
            if (response.data.status) {
              _this.$swal("Success", "Agent Approved successfully", "success");
              _this.getAgentList();
              _this.hasDeleted = false;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    async reject(uuid) {
      var _this = this;
      try {
        axios
          .put("/api/agent/reject", {
            accessToken: localStorage.getItem("access_tocken"),
            approval_remark: _this.reason,
            uuid: uuid,
          })
          .then(function (response) {
            if (response.data.status) {
              _this.$swal("Success", "Agent Rejected Successfully", "success");
              _this.getAgentList();
              _this.hasDeleted = false;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout   @CustomEventInputChangedAll="searchFilterFunc2">
     <AgentDetails v-if="show" :visible='show' v-on:agentPending="onPending"v-on:agentApproval="onApproval" v-on:agentRejection="onRejection"  v-on:childToParent="onApprovalMessage" :agentUuid="this.agentUuid" ref="child">
     </AgentDetails>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>

            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                  <thead>
                  <tr>
                      <th>Agent ID</th>
                      <th>
                          <div class="row">
                              <div class="col-xs-4">Login ID</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">Company Name/Balance/loan</div>
                          </div>
                      </th>
                      <th>User/Contact Info </th>
                      <th>Owner Info</th>
                      <th>
                          <div class="row">
                              <div class="col-xs-4">City</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">State/Country</div>
                          </div>

                      </th>
                      <th>Action</th>
                      <!--                      <th>Currency</th>-->
                      <!--                      <th>Language</th>-->
                      <!--                      <th>Balance</th>-->
                      <!--                      <th>Loan</th>-->
                      <!--                      <th>Status</th>-->
                      <!--                      <th></th>-->
                      <!--                    <th>Action</th>-->
                      <!--                      <th></th>-->
                  </tr>
                  <tr>
                      <td> <input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search id" /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email / agency Name" /></td>
                      <!--                    <td><input type="text" class="app-search form-control" v-model="search_phone" placeholder="Search " /></td>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(agent,index) in filteredList" v-bind:key="index">
                      <td v-if="agent.users!=undefined">{{agent.users[0].username!=null?agent.users[0].username:'N/A'}}  <i class="bx bx-x"></i>pending</td>
                      <td v-else>null</td>
                      <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.email}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> {{agent.agency_information[0].agency_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.currency : 'N/A' }}</b-badge>  <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.main_balance : 'N/A' }}</b-badge> <b-badge variant="danger" class="ml-1">{{agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.loan_balance : 'N/A'}}</b-badge></div>
                          </div>
                      </td>
                      <td v-else>N/A</td>

                      <td class="padding-5px-right">
                          <div class="row">
                              <div class="col-xs-4">{{agent.first_name}} {{agent.last_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.phone_code}} {{agent.phone_number}}</div>
                          </div>

                      </td>
                      <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_full_name==null ? 'N/A' : agent.agency_information[0].management_full_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_phone_number==null ? 'N/A' : agent.agency_information[0].management_phone_number}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_email==null ? 'N/A' : agent.agency_information[0].management_email}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <td  class="padding-5px-right"   v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].city==null ? 'N/A' : agent.agency_information[0].city}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].address==null ? 'N/A' : agent.agency_information[0].address}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> {{agent.agency_information[0].country == null ? 'N/A' : agent.agency_information[0].country}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.main_balance }}</td>-->
                      <!--                      <td v-else>0</td>-->
                      <!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.loan_balance }}</td>-->
                      <!--                      <td v-else>0</td>-->
                      <!--                      <td v-if="agent.users!=undefined">{{agent.users[0].status}}</td>-->
                      <!--                      <td v-else >null</td>-->
                      <td><button @click.prevent="approvalAction(agent)" class="btn btn-primary btn-small">Action</button> </td>
<!--                      <td>-->
<!--                          <b-dropdown dropright>-->
<!--                              <template v-slot:button-content>-->
<!--                                  Action-->
<!--                                  <i class="mdi mdi-chevron-down"></i>-->
<!--                              </template>-->
<!--                              <b-dropdown-item><b-button class="btn btn-primary btn-sm"  v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)">Details</b-button></b-dropdown-item>-->
<!--                              <b-dropdown-item><router-link :to="{ name: 'agent_update', params: {type:'approve',uuid: agent.uuid}}" class="btn btn-primary btn-sm"> Edit</router-link></b-dropdown-item>-->
<!--                              <b-dropdown-item><button v-if="agent.users[0].status=='active'" class="btn btn-primary btn-sm" @click.prevent="userStatusWarning(agent.users[0].uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Activate</button></b-dropdown-item>-->
<!--                          </b-dropdown>-->
<!--                      </td>-->
                      <!--                    <td><b-button class="btn btn-primary btn-small"  v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)">Details</b-button></td>-->
                      <!--                      <td><router-link :to="{ name: 'agent_update', params: {type:'approve',uuid: agent.uuid}}" class="btn btn-primary btn-small"> Edit</router-link></td>-->
                      <!--                      <td  align='center'><button v-if="agent.users[0].status=='active'" class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Activate</button></td>-->
                  </tr>
                  </tbody>
<!--                <tbody>-->
<!--                  <tr v-for="(agent,index) in filteredList" v-if="agent.approval_status == 'pending' && agent.agency_information[0] != undefined" v-bind:key="index">-->
<!--                    <th scope="row">{{agent.new_index}}</th>-->
<!--                    <td>{{agent.first_name}}</td>-->
<!--                    <td>{{agent.last_name}}</td>-->
<!--                      <td v-if="agent.users[0].username!=null">{{agent.users[0].username}}</td>-->
<!--                      <td v-else >null</td>-->
<!--                    <td>{{agent.email}}</td>-->
<!--                    <td>{{agent.phone_code}} {{agent.phone_number}}</td>-->
<!--                    <td><button @click.prevent="approvalAction(agent)" class="btn btn-primary btn-small">Action</button> </td>-->
<!--                  </tr>-->
<!--                </tbody>-->
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.padding-5px-right{
    word-break: break-all;
    overflow: auto;
}
.table-responsive img{
    width:60px;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
</style>
<!--<style scoped>-->
<!--table>tr>td{-->
<!--    width:30%;-->
<!--    height:30px;-->
<!--}-->
<!--.margin-5px{-->
<!--    margin-right: 5px;-->
<!--}-->
<!--.width-20px{-->
<!--    table-layout: fixed;-->
<!--    width: 20px;-->
<!--}-->
<!--.padding-5px{-->
<!--    padding-right: 3%;-->
<!--    padding-left: 3%;-->
<!--}-->
<!--/*.padding-5px-right{*/-->
<!--/*    word-break: break-all;*/-->
<!--/*    overflow: auto;*/-->
<!--/*}*/-->
<!--.table-responsive img{-->
<!--    width:60px;-->
<!--}-->
<!--table>tr>td:nth-child(odd) {-->
<!--    font-weight: 600;-->
<!--}-->
<!--</style>-->
